import { createTheme, ThemeOptions } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/core/styles/withStyles';
import { defaultsDeep } from 'lodash'
import { muiTheme as defaultTheme } from '../styleUtils'

type PickersTheme = {
  overrides: ThemeOptions['overrides'] & {
    MuiPickersToolbar: ThemeOptions['overrides']['MuiToolbar'] & {
      toolbar: CSSProperties
    },
    MuiPickersToolbarText: {
      toolbarBtnSelected: CSSProperties
      toolbarTxt: CSSProperties
    }
  }
}

const theme: ThemeOptions & PickersTheme = {
  palette: {
    type: 'dark',
    action: {
      active: "rgba(255, 255, 255, 0.54)",
      disabled: "rgba(255, 255, 255, 0.26)",
      disabledBackground: "rgba(255, 255, 255, 0.12)",
      focus: "rgba(255, 255, 255, 0.12)",
      hover: "rgba(255, 255, 255, 0.04)",
      selected: "rgba(255, 255, 255, 0.08)",
    },
    background: {
      default: '#111111',
      paper: '#262626',
    },
    divider: 'rgba(255,255,255,0.12)',
    primary: {

    },
    secondary: {

    },
    text: {
      primary: 'rgba(255,255,255,0.87)',
      secondary: 'rgba(255,255,255,0.54)',
      disabled: 'rgba(255, 255, 255, 0.26)',
      hint: 'rgba(255,255,255, 0.54)'
    },
  },
  typography: {
    h1: {
      color: 'rgba(255,255,255,0.87)',
    },
    h2: {
      color: 'rgba(255,255,255,0.87)',
    },
    h3: {
      color: 'rgba(255,255,255,0.87)',
    },
    h4: {
      color: 'rgba(255,255,255,0.87)',
    },
    h5: {
      color: 'rgba(255,255,255,0.87)',
    },
    h6: {
      color: 'rgba(255,255,255,0.87)',
    },
    subtitle1: {
      color: 'rgba(255,255,255,0.87)',
    },
    subtitle2: {
      color: 'rgba(255,255,255,0.87)',
    },
    caption: {
      color: 'rgba(255,255,255,0.87)',
    },
    overline: {
      color: 'rgba(255,255,255,0.87)',
    },
    body1: {
      color: 'rgba(255,255,255,0.87)'
    },
    body2: {
      color: 'rgba(255,255,255,0.87)'
    }
  },
  overrides: {
    MuiButton: {
      contained: {
        backgroundColor: 'none',

        '&:hover': {
          backgroundColor: 'rgba(128,128,128,0.2)',
        },

        '&$disabled': {
          color: 'rgba(255, 255, 255, 0.26)',
          backgroundColor: 'rgba(128, 128, 128, 0.12)',
        }
      },
      containedPrimary: {
        color: '#fff',
        backgroundImage: 'none',
        '&:hover': {}
      },
      text: {
        '&:hover': {
          backgroundColor: 'rgba(128,128,128,0.2)',
        }
      }
    },
    MuiDialogTitle: {},
    MuiDivider: {
      root: {
        backgroundColor: 'rgba(128,128,128,0.2)',
        height: '1px'
      }
    },
    MuiFormControlLabel: {
      label: {
        '&$disabled': {
          color: 'rgba(128,128,128, 0.54)'
        }
      }
    },
    MuiFormLabel: {
      root: {
        '&$disabled': {
          color: 'rgba(128,128,128, 0.54)'
        }
      }
    },
    MuiIcon: {
      colorAction: {
        color: 'rgba(255,255,255,0.54)'
      }
    },
    MuiIconButton: {
      root: {
        color: 'rgba(255,255,255,0.54)',
        '&$disabled': {
          color: 'rgba(255,255,255,0.26)',
          opacity: 0.3,
        }
      },
    },
    MuiInput: {
      underline: {
        '&:before': {
          borderBottomColor: 'rgba(128,128,128,0.2)'
        },
        '&:hover:not(.Mui-disabled):before': {
          borderBottomColor: 'rgba(128,128,128,0.24)'
        }
      }
    },
    MuiInputLabel: {
      root: {
        color: 'rgba(255,255,255,0.54)'
      }
    },
    MuiInputBase: {
      root: {
        '&$disabled': {
          color: 'rgba(128,128,128,0.54)'
        }
      },
      input: {
        '&:-webkit-autofill': {
          '-webkit-box-shadow': '0 0 0 2.5em #262626 inset',
          '-webkit-text-fill-color': 'rgba(255,255,255,.87)',
        }
      }
    },
    MuiListItem: {
      button: {
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,0.04)'
        }
      }
    },
    MuiListItemText: {
      root: {
        color: 'rgba(255,255,255,0.87)'
      }
    },
    MuiOutlinedInput: {
      root: {
        '&$disabled $notchedOutline': {
          borderColor: 'rgba(255,255,255,0.26)'
        }
      }
    },
    MuiTableRow: {
      root: {
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,0.04)'
        }
      },
      hover: {
        '&:hover': {
          backgroundColor: 'rgba(255,255,255,0.04)'
        }
      },
    },
    MuiSelect: {
      icon: {
        color: 'rgba(255,255,255,0.87)'
      }
    },
    MuiSvgIcon: {
      root: {
        color: 'rgba(255,255,255,0.87)'
      },
      colorAction: {
        color: 'rgba(255,255,255,0.54)'
      }
    },
    MuiPaper: {
      root: {
        background: '#262626'
      },
      elevation1: {
        boxShadow: '0px 2px 1px -1px rgba(128,128,128,0.1), 0px 1px 1px 0px rgba(128,128,128,0.04), 0px 1px 3px 0px rgba(128,128,128,0.02)'
      }
    },
    MuiTableCell: {
      root: {
        borderBottomColor: 'rgba(128,128,128,0.2)'
      }
    },
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: '#262626'
      }
    },
    MuiPickersToolbarText: {
      toolbarBtnSelected: {
        color: 'rgba(255,255,255,0.87)'
      },
      toolbarTxt: {
        color: 'rgba(255,255,255,0.54)'
      }
    },
  }
}

export default createTheme(defaultsDeep(theme, defaultTheme))
